import SectionSeparator from "components/MdxSectionSeparator/sectionSeparator.jsx";
import imgJIR1 from "assets/img/blogs/adot-java-instrumentation/Functional_Overview.png";
import * as React from 'react';
export default {
  SectionSeparator,
  imgJIR1,
  React
};